import React, { useCallback, useRef, useState } from 'react';
import { Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import XPathGrid from '../../components/xpath/XPathGrid';
import { AlertSeverity, IAlertType } from '../../constants/AlertTypes';
import { useConfigurationSave } from '../../hooks/useConfigurationSave';

const XpathMappings: React.FC = () => {
    const [isGlobalSave, setIsGlobalSave] = useState<boolean>(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState<AlertSeverity>('info');
    const pendingSaveRef = useRef<{ resolve: () => void; reject: (error: unknown) => void } | null>(null);

    const handleSave = useCallback(() => {
        return new Promise<void>((resolve, reject) => {
            pendingSaveRef.current = { resolve, reject };
            setIsGlobalSave(true);
        });
    }, []);

    const handleGlobalSaveComplete = useCallback((error?: unknown) => {
        if (!pendingSaveRef.current) return;
        const { resolve, reject } = pendingSaveRef.current;
        pendingSaveRef.current = null;
        if (error) {
            reject(error);
            return;
        }
        resolve();
    }, []);

    // Register save function for header buttons
    useConfigurationSave(() => handleSave());

    const handleAlert = (alertData: IAlertType) => {
        setAlertMessage(alertData.message);
        setAlertSeverity(alertData.severity);
        setAlertOpen(true);
    }

    const handleSnackBarClose = () => setAlertOpen(false);

    return (
        <section>
            <XPathGrid
                setMainAlert={handleAlert}
                setMainLoading={() => {}}
                setIsGlobalSave={() => setIsGlobalSave(false)}
                isGlobalSave={isGlobalSave}
                onGlobalSaveComplete={handleGlobalSaveComplete}
            />
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={alertOpen}
                autoHideDuration={4000}
                onClose={handleSnackBarClose}
            >
                <MuiAlert
                    onClose={handleSnackBarClose}
                    severity={alertSeverity}
                    sx={{ width: '100%', fontSize: '1.2rem', padding: '12px 16px' }}>
                    {alertMessage}
                </MuiAlert>
            </Snackbar>
        </section>
    );
}

export default XpathMappings;
